const strings: [string, string][] = [
  ['toolbar-select', 'select'],
  ['toolbar-delete', 'delete [Del]'],
  ['toolbar-save', 'save'],
  ['toolbar-undo', 'undo'],
  ['toolbar-redo', 'redo'],
  ['toolbar-add', 'add a stencil [N]'],
  ['toolbar-document-setup', 'document properties'],
  ['toolbar-zoomin', 'zoom in'],
  ['toolbar-zoomreset', 'reset zoom'],
  ['toolbar-zoomout', 'zoom out'],
  ['toolbar-properties', 'toggle toolbox'],
  ['toolbar-connect', 'connect [C]'],
  
  ['toolbox-shape-title', 'Shape properties'],
  ['toolbox-linecolor-title', 'Line color'],
  ['toolbox-fillcolor-title', 'Fill color'],
  ['toolbox-linewidth-title', 'Line width'],
  ['toolbox-linestyle-title', 'Line style'],
  ['toolbox-arrowtype-title', 'Arrow type'],

  ['toolbox-text-title', 'Text properties'],
  ['toolbox-textcolor-title', 'Text color'],
  ['toolbox-font-title', 'Font'],
  ['toolbox-increasefontsize-title', 'increase font size'],
  ['toolbox-decreasefontsize-title', 'decrease font size'],
  
  ['toolbox-image-title', 'Image'],
  ['toolbox-label-location-title', 'Text location'],
  ['toolbox-click-to-select-image', 'click to select image'],
  
  ['toolbox-connectortype-title', 'Connector type'],
  
  ['toolbox-newstencil-title', 'Create new'],
  ['toolbox-bgcolor-title', 'Background color'],
  ['toolbox-docsize-title', 'Document size'],
  
  ['toolbox-align-title', 'Align'],
  ['toolbox-align-left', 'Left'],
  ['toolbox-align-center', 'Center'],
  ['toolbox-align-right', 'Right'],
  ['toolbox-align-top', 'Top'],
  ['toolbox-align-middle', 'Middle'],
  ['toolbox-align-bottom', 'Bottom'],
  
  ['toolbox-arrange-title', 'Arrange'],
  ['toolbox-arrange-front', 'Bring to front'],
  ['toolbox-arrange-forward', 'Bring forward'],
  ['toolbox-arrange-backward', 'Send backward'],
  ['toolbox-arrange-back', 'Send to backw'],
  
  ['toolbox-widthshort-label', 'W:'],
  ['toolbox-heightshort-label', 'H:'],

  ['RectangleTextStencil-displayname', 'Text box'],
  ['EllipseStencil-displayname', 'Ellipse'],
  ['DiamondStencil-displayname', 'Diamond'],
  ['LabelStencil-displayname', 'Lable'],
  ['LightbulbIconStencil-displayname', 'Lightbulb'],
  ['BitmapImageStencil-displayname', 'Image'],
];

export default strings;
